import { gql } from '@apollo/client';

export const UPSERT_INDICATOR_PERIOD_DATES = gql`
  mutation upsertIndicatorPeriodDates($input: UpsertIndicatorPeriodDatesInput!) {
    indicatorPeriodDates: upsertIndicatorPeriodDates(input: $input) {
      id
    }
  }
`;
